<template>
  <div class="page">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.page {
  overflow-x: hidden;
  height: 100%;
  background: #fbfbfb;
  overflow-y: scroll;
  /* 解决ios卡顿问题 */
  touch-action: pan-y;
  // -webkit-overflow-scrolling: touch;
  // z-index: 1;
}
.page::-webkit-scrollbar {
  width: 0 !important;
}
</style>
